import type { ReactElement } from 'react';
import { memo } from 'react';

import type { StyleOption } from '../gql';

import Box, { type BoxProps } from '@mui/material/Box';

import { findStyleOptionImage, isDefined } from '../utils';

interface StyleOptionImageProps extends BoxProps {
    styleOption: StyleOption;
    size?: number;
}

const StyleOptionImageRaw = ({
    styleOption,
    size = 32,
    ...boxProps
}: StyleOptionImageProps): ReactElement => {
    const thumbnailImage = findStyleOptionImage(
        styleOption.pictures.filter(isDefined),
        'microthumbnail'
    );

    return (
        <Box
            {...boxProps}
            sx={{
                minWidth: size,
                width: size,
                minHeight: size,
                bgcolor: thumbnailImage
                    ? 'transparent'
                    : styleOption.masterColourHexCode,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundImage: thumbnailImage
                    ? `url(${thumbnailImage.url})`
                    : undefined,
                // eslint-disable-next-line @typescript-eslint/no-misused-spread
                ...boxProps.sx,
            }}
        />
    );
};

export const StyleOptionImage = memo(StyleOptionImageRaw);
